import  { Component } from 'react';

class  PrivacyPolicy extends Component {
    
    componentDidMount() {
        
    }
    
    render(){
        return (
           <div className='privacy-policy-container'>
                <h3 style={{margin:'0'}}>Privacy Policy</h3><br></br><span>Last updated: May 21, 2025</span>               
                <div>
                <h3>Cookies and Local Storage</h3>
                <div><p>
                <strong>Essential Cookie (CoreUI):</strong> We use one essential cookie provided by the CoreUI framework. This cookie is required for basic website functionality and cannot be disabled.
                </p>
                </div>
                <div>
                    <p>
                    <strong>Analytics Consent (Local Storage):</strong> We do not load Google Analytics unless you explicitly consent. Your consent is stored in your browser’s local storage using a key that enables or disables the analytics script. No personal information is stored in this process.
                    </p>
                </div>
                </div>

<div>
  <h3>Google Analytics</h3>
  <div>
  <p>
  With your consent, we use Google Analytics to gather anonymous usage data to improve our website.<br>
  </br> This includes information such as:<br></br>
   Pages visited, time spent on pages, browser and device type.<br></br>
   You can opt out at any time by clicking the rejection button, which will stop data collection and disable the analytics script.
  </p>
  </div>
</div>

<div>
  <h3>Newsletter Sign-Up</h3>
  <div>
  <p>If you subscribe to our newsletter via the contact form, we collect and store your email address securely on our server. We use this information only to send you occasional updates and never share your email with third parties.
  </p>
  </div>
  <div>
  <p>
  You can unsubscribe at any time by contacting us or using the unsubscribe link in any newsletter email.

  </p>
  </div>
</div>

<div>
  <h3>Data Sharing</h3>
  <div>
  <p>
  We do <strong>not</strong> sell, rent, or share your personal data with third parties. Google Analytics data is anonymized and used only to improve the site.
  </p>
  </div>
</div>
<div>
  <h3>Your Rights</h3>
  <div>
  <p>
  Depending on your location, you may have the right to request access to your personal data, request deletion (e.g., removal from the newsletter list), or withdraw consent for analytics at any time.
  </p>
  </div>
  <div>
  <p>
  Please contact us if you'd like to exercise any of these rights.
  </p>
  </div>
</div>
<div>
  <h3>Contact</h3>
  <div>
  <p> If you have any questions about this policy or your data, feel free to contact us at admin@sagishutrit.nl
  </p>
  </div>
</div>
</div>
        )
    }
}
export default PrivacyPolicy;